<template>
  <div class="header">
    <div class="header__left">
      <button @click="$router.push(backLink)" class="btn header__backlink" v-if="backLink" v-blur-on-click>
        ←
      </button>
    </div>
    <router-link to="/" class="header__title" v-blur-on-click>Warehouse</router-link>
    <div class="header__right"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backLink: null
    }
  },
  mounted() {
    if (this.$route.meta.backLink) this.backLink = this.$route.meta.backLink
  },
  watch: {
    '$route.meta.backLink': {
      handler(backLink) {
        this.backLink = backLink
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: calc(env(safe-area-inset-top) + 1rem) calc(env(safe-area-inset-right) + 1rem) 1rem
    calc(env(safe-area-inset-left) + 1rem);
  z-index: 10;

  background: $color-main;

  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__backlink {
    width: 2rem;
    height: 2rem;
    padding: 0;

    border-color: #ccc;

    color: #fff;
    font-size: 16px;
    line-height: 2rem;
    text-align: center;
  }

  &__left,
  &__right {
    width: 4rem;
  }

  &__title {
    display: inline-block;

    color: #fff;
    font-size: 1.5rem;
    text-align: center;

    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
}
</style>
